import { render } from "./candidate-field-input.vue?vue&type=template&id=cd8f15a4"
import script from "./candidate-field-input.vue?vue&type=script&lang=js"
export * from "./candidate-field-input.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__